import {
    SignupPageState,
    SignupPagesState,
    initialSignupPageState,
    initialSignupPagesState,
} from "@/mk2/apps/users/containers/Signup/Signup.reducers";
import { AppState } from "@/mk2/reducers";

const getSignupPagesState = (state: AppState): SignupPagesState =>
    state.containers.users.signup ?? initialSignupPagesState;

export const getSignupPageState = (state: AppState, key: string): SignupPageState =>
    getSignupPagesState(state)[key] ?? initialSignupPageState;
